import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  ProgressIndicator,
  ProgressIndicatorSkeleton,
  ProgressStep,
  Modal,
  Loading,
} from 'carbon-components-react';
import { Breadcrumb, Tabs } from '../../../../components';
import { getByDmService, pathDmService, insertDmService } from '../../../../services/Api';
import { getStatusIndex } from '../../../../utils/modifiers';
import Detail from './Detail';
import Infos from './Infos';
import Comments from './Comments';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      isUpdating: false,
      cancelModal: false,
      modalSac: false,
      idPedidoEmail: 0
    };
  }

  componentDidMount() {
    this.loadCampaign();
    this.countComment()
  }

  loadCampaign = async () => {
    const { match } = this.props;

    try {
      const data = await getByDmService('Pedido/GetDataCampanhaMensagem', match.params.id);
      console.log("loadCampaign", data);
      await this.countComment(data.itensCampanhaMensagem[0].id);
      this.setState({ data, isLoading: false, idPedidoEmail: data.id });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null /* , error: e */, isLoading: false });
    }
  };

  enviarEmailSac = async () => {

    const { idPedidoEmail: idPedido } = this.state;

    try {
      await insertDmService('/Pedido/EnvioEmailSAC', { idPedido });
      toast.info('Informações enviadas para o SAC');
      await this.loadCampaign();
      this.toggleInfoSacModal();
    } catch (e) {
      toast.error('Ocorreu um erro ao enviar para o SAC');
    }
  };

  toggleInfoSacModal = () => {
    this.setState(prevState => ({ modalSac: !prevState.modalSac }));
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  updateOrderStatus = async status => {
    const { data } = this.state;
    const { match } = this.props;
    const id = status === 7 ? match.params.id : data.id;
    const serviceUrl =
      status === 7
        ? `/Pedido/AtualizaStatusData/${id}?status=${status}`
        : `/Pedido/AtualizaStatus/${id}?status=${status}&retirouUniforme=&dataRetiradaUniforme=`;

    this.setState({ isUpdating: true });

    try {
      await pathDmService(serviceUrl);
      await this.loadCampaign();
      this.setState({ isUpdating: false });
      return Promise.resolve();
    } catch (e) {
      toast.error('Ocorreu um erro ao alterar o status do pedido');
      this.setState({ isUpdating: false });
      return Promise.reject();
    }
  };

  approveOrder = async () => {
    await this.updateOrderStatus(6);
    toast.success('O pedido foi aprovado');
  };

  scheduleShipping = async () => {
    await this.updateOrderStatus(7);
    toast.success('O pedido foi programado');
  };

  cancelOrder = async () => {
    await this.updateOrderStatus(5);
    toast.info('O pedido foi cancelado');
    this.toggleCancelModal();
  };

  giveBackOrder = async () => {
    await this.updateOrderStatus(4);
    toast.info('O pedido foi devolvido');
  };

  goBackList = () => {
    const { history } = this.props;
    const urlReturn = localStorage.getItem('urlReturn');
    history.push(urlReturn);
  };

  countComment = async idRequest => {
    try {
      const dataComent = await getByDmService('/Comentario/GetByItemPedido', idRequest);
      const numberComents = await dataComent.length;
      await this.setState({
        nrComents: numberComents
      });
    } catch (error) {
      console.log("error")
      console.log(error);
    }

  }

  render() {
    const { data, isLoading, isUpdating, cancelModal, nrComents, modalSac } = this.state;
    const { match } = this.props;
    const orderStatus = data && data.status;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <Tabs
              sections={[
                { title: 'Detalhe da Campanha', path: `${match.url}/detalhe` },
                { title: 'Informações da Campanha', path: `${match.url}/informacoes` },
                { title: 'Comentários', path: `${match.url}/comentarios`, badge: nrComents },
              ]}
            />
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    const statusIndex = getStatusIndex(orderStatus.id || 0);
    const orderStatusId = orderStatus.id;
    const campaignSendDate = data.itensCampanhaMensagem[0].datasEnvio[0].dataEnvioFormatada;

    return (
      <div>
        <Breadcrumb
          title={`${data.numero} - ${campaignSendDate} - ${data.descricao}`}
          description={`Criada por ${data.solicitante.nome}`}
          renderLeft={(() => (
            <div className="breadcrumb-left-actions pointer" onClick={() => this.goBackList()}>
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
          renderRight={
            statusIndex !== 5
              ? (() => (
                <div className="flex v-sm-margin">
                  {[7, 8].indexOf(orderStatusId) > -1 && (
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      onClick={this.toggleInfoSacModal}
                      type="submit"
                    >
                      Informações SAC
                    </button>
                  )}
                  <button
                    className="bx--btn btn-primary-outlined h-sm-margin"
                    onClick={this.toggleCancelModal}
                    type="submit"
                  >
                    Cancelar Campanha
                  </button>
                  {statusIndex === 0 && (
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      onClick={this.giveBackOrder}
                      type="submit"
                    >
                      Devolver
                    </button>
                  )}
                  {statusIndex === 2 && (
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      onClick={this.scheduleShipping}
                      type="submit"
                    >
                      Programar
                    </button>
                  )}
                  {statusIndex < 2 && (
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      onClick={this.approveOrder}
                      type="submit"
                    >
                      Aprovar
                    </button>
                  )}
                </div>
              ))()
              : (() => (
                <button type="submit" className="bx--btn btn-primary-outlined h-sm-margin" disabled>
                  Pedido cancelado
                </button>
              ))()
          }
        />
        <section className="content-wrapper content-wrapper--large">
          <Tabs
            sections={[
              { title: 'Detalhe da Campanha', path: `${match.url}/detalhe` },
              { title: 'Informações da Campanha', path: `${match.url}/informacoes` },
              { title: 'Comentários', path: `${match.url}/comentarios`, badge: nrComents },
            ]}
          />

          <ProgressIndicator className="v-xl-margin" currentIndex={statusIndex}>
            <ProgressStep label="Pendente" />
            <ProgressStep label="Devolvido" />
            <ProgressStep label="Aprovado" />
            <ProgressStep label="Programado" />
            <ProgressStep label="Enviado" />
            <ProgressStep label="Cancelado" />
          </ProgressIndicator>

          <Route
            path={`${match.url}/detalhe`}
            component={props => <Detail data={data} loadCampaign={this.loadCampaign} {...props} />}
          />
          <Route
            path={`${match.url}/informacoes`}
            component={props => <Infos data={data} loadCampaign={this.loadCampaign} {...props} />}
          />
          <Route
            path={`${match.url}/comentarios`}
            component={props => <Comments order={data} {...props} updateCount={e => this.countComment(e)} />}
          />

          <Modal
            open={cancelModal}
            onRequestSubmit={this.cancelOrder}
            onRequestClose={this.toggleCancelModal}
            modalHeading="Cancelar Campanha"
            primaryButtonText="Tenho certeza"
            secondaryButtonText="Cancelar"
          >
            <div className="warning-modal-txt">
              <p>Você tem certeza que deseja cancelar esta campanha?</p>
            </div>
          </Modal>

          <Modal
            open={modalSac}
            onRequestSubmit={this.enviarEmailSac}
            onRequestClose={this.toggleInfoSacModal}
            modalHeading="Informações SAC"
            primaryButtonText="Tenho certeza"
            secondaryButtonText="Cancelar"
          >
            <div className="warning-modal-txt">
              <p>Enviar orientações para o e-mail do SAC?</p>
            </div>
          </Modal>
          {isUpdating && <Loading small />}
        </section>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/Detail/Main.js